export default {
    styleCanBeApplied: true
}
